import React from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import Budget from "../../components/Budget/Budget";
import Remaining from "../../components/Budget/Remaining";
import ExpenseTotal from "../../components/Budget/ExpenseTotal";
import ExpenseList from "../../components/Budget/ExpenseList";
import AddExpenseForm from "../../components/Budget/AddExpenseForm";
import { BudgetProvider } from "../../context/budget.context";
import "./BudgetPage.css";

import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import { useTranslation } from "react-i18next";
import enTranslations from "../../en.json";
import arTranslations from "../../ar.json";

i18n.use(initReactI18next).init({
  resources: {
    en: { translation: enTranslations },
    ar: { translation: arTranslations },
  },
  lng: "en",
  fallbackLng: "en",
  interpolation: { escapeValue: false },
});

export default function BudgetPage() {
  const { t } = useTranslation();
  return (
    <BudgetProvider>
      <div className="container">
        <h1 className="mt-3 title "> {t("mybudget")}</h1>
        <div className="row mt-3">
           {/* <div className="col-sm">
            <Budget />
          </div>
          <div className="col-sm">
            <Remaining />
          </div>  */}
          <div className="col-sm">
            <ExpenseTotal />
          </div> 
        </div>
        <h3 className="mt-3"> {t("expenses")}</h3>
        <div className="row mt-3">
          <div className="col-sm">
            <ExpenseList />
          </div>
          <h3 className="mt-3"> {t("additem")}</h3>
          <div className="mt-3">
            <div className="col-sm">
              <AddExpenseForm />
            </div>
          </div>
        </div>
      </div>
    </BudgetProvider>
  );
}
